import React from 'react';
import PropTypes from 'prop-types';
import OverviewTable from '../base/Table/OverviewTable';
import Button from '../base/Button/GlyphedButton';
import {SEARCH_GLYPH} from '../../const/Glyphicons';
import textTranslates from './translate.json';
import './WaybillData.scss';

const WaybillDataPreview = (props) => {
    return(
        <OverviewTable
            tableId="waybillNumberTable">
            <tbody>
                <tr id="waybillDataWaybillNumber" className="waybillNumber">
                    <td className="col-xs-4 col-sm-4 col-md-2"> 
                        <p>{textTranslates.waybillNumberTableLabel}</p>
                    </td>
                    <td className="col-xs-8 col-sm-8 col-md-10">
                        <p> {props.waybillNumber} </p>
                    </td>
                </tr>
                <tr id="waybillDataWaybillCourier" className="waybillNumber">
                    <td className="col-xs-4 col-sm-4 col-md-2"> 
                        <p>{textTranslates.waybillCourierTableLabel}</p>
                    </td>
                    <td className="col-xs-8 col-sm-8 col-md-10">
                        <p> {props.waybillCourier.displayName} </p>
                    </td>
                </tr>
                {props.showEditButton &&
                <tr>
                    <td className="col-xs-4 col-sm-4 col-md-2"> 
                        <p>{textTranslates.editWaybillDataTableLabel}</p>
                    </td>
                    <td className="col-xs-2 col-sm-2 col-md-2">
                    <Button
                        onClick={props.onEditWaybillDataButtonClick}
                        label={textTranslates.waybillNumberEditButtonText}
                        glyph={SEARCH_GLYPH} />
                    </td>
                </tr>}
            </tbody>
        </OverviewTable>
    );
};

WaybillDataPreview.propTypes = {
    showEditButton: PropTypes.bool,
    waybillNumber: PropTypes.string,
    waybillCourier: PropTypes.object,
    onEditWaybillDataButtonClick: PropTypes.func
};

export default WaybillDataPreview;


// WEBPACK FOOTER //
// ./src/components/WaybillData/WaybillDataPreview.js